import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { crmOfferDetailsModel } from 'src/app/models/crm.model';
import { createHttpParams } from 'src/app/shared/utils/create-http-params.utils';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class CRMService extends BaseService<crmOfferDetailsModel> {
  constructor(protected http: HttpClient) {
    super(http, 'crm');
  }

  getCRMOffers(): Observable<any> {
    return this.http.get(`${this.resourceUrl}/offers`, {
      observe: 'response'
    });
  }

  getOfferDetails(
    searchValues: any
  ): Observable<HttpResponse<crmOfferDetailsModel>> {
    const params = createHttpParams(searchValues);
    return this.http.get<crmOfferDetailsModel>(
      `${this.resourceUrl}/offer/details`,
      {
        params,
        observe: 'response'
      }
    );
  }

  countOffers(): Observable<HttpResponse<{ data: number }>> {
    return this.http.get<{ data: number }>(`${this.resourceUrl}/count-offers`, {
      observe: 'response'
    });
  }

  sendOfferInteraction(body: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(`${this.resourceUrl}/offer/interaction`, body, {
      observe: 'response'
    });
  }
}
